/*!
 * This file contains stuff for the frontend and editor parts
 *
 * @package Olenka Theme Starter Kit
 * @author Maksym Marko <markomaksym@gmail.com>
 *
 * @link https://markomaksym.com.ua/
 !*/
 
import './assets/css/editor-frontend.css'

; (function ($) {
    $(function () {});
})(jQuery);